import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { getContent, createContent, updateContent } from '../store/slices/contentSlice';

function ContentEditor() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentContent, isLoading } = useSelector((state) => state.content);
  
  const [formData, setFormData] = useState({
    title: '',
    body: '',
    description: '',
    type: 'article',
    category: 'general',
    tags: '',
    status: 'draft'
  });
  
  useEffect(() => {
    if (id) {
      dispatch(getContent(id));
    }
  }, [id, dispatch]);
  
  useEffect(() => {
    if (currentContent && id) {
      setFormData({
        title: currentContent.title || '',
        body: currentContent.body || '',
        description: currentContent.description || '',
        type: currentContent.type || 'article',
        category: currentContent.category || 'general',
        tags: currentContent.tags?.join(', ') || '',
        status: currentContent.status || 'draft'
      });
    }
  }, [currentContent, id]);
  
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    const contentData = {
      ...formData,
      tags: formData.tags.split(',').map(t => t.trim()).filter(Boolean)
    };
    
    if (id) {
      await dispatch(updateContent({ id, data: contentData }));
    } else {
      await dispatch(createContent(contentData));
    }
    navigate('/content');
  };
  
  return (
    <div className="content-editor">
      <h1>{id ? 'Edit Content' : 'Create Content'}</h1>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Body</label>
          <textarea
            name="body"
            value={formData.body}
            onChange={handleChange}
            rows={10}
            required
          />
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Type</label>
            <select name="type" value={formData.type} onChange={handleChange}>
              <option value="article">Article</option>
              <option value="post">Post</option>
              <option value="page">Page</option>
              <option value="news">News</option>
            </select>
          </div>
          <div className="form-group">
            <label>Category</label>
            <input
              type="text"
              name="category"
              value={formData.category}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="form-group">
          <label>Tags (comma separated)</label>
          <input
            type="text"
            name="tags"
            value={formData.tags}
            onChange={handleChange}
          />
        </div>
        <button type="submit" disabled={isLoading}>
          {isLoading ? 'Saving...' : 'Save'}
        </button>
      </form>
    </div>
  );
}

export default ContentEditor;